import invariant from 'invariant';
import isArray from "ramda-extension/es/isArray";
import isNotNil from "ramda-extension/es/isNotNil";
import { fieldType } from '../../validations/constants';
export const invariantFieldArray = (fieldDescriptor, fieldName, fieldIndices)=>{
    const isFieldOrArray = fieldDescriptor.type === fieldType.FIELD || fieldDescriptor.type === fieldType.ARRAY;
    const isFieldArrayWithIndices = fieldDescriptor.type === fieldType.FIELD_ARRAY && isNotNil(fieldIndices);
    invariant(isFieldOrArray || isFieldArrayWithIndices, `For ${fieldName} fieldIndices must be presented, because it is arrayType`);
};
export const invariantDeepPathArray = (deepPath)=>invariant(isArray(deepPath), `deepPath ${deepPath} must be array`);
